<template>
    <list class="m-0 p-0" v-model="questionnaires" :columns="columns" :pagination="pagination"
          :actions="actions"
          :sort-change="sortChange"
          :edit="(props) => $router.push({ name: 'QuestionnaireEdit', params: { id: props.row.$id } })"
          :remove="(props) => confirmAndDelete(props.row)"
          search-enabled
          :search-query="query"
          @search-change="searchInput"
    />
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import BaseList from '../../Views/BaseList'
  import QuestionnaireModel from 'src/store/models/Questionnaire'
  import List from '../../Components/BasicList'

  export default {
    extends: BaseList,
    name: 'QuestionnaireList',
    components: { List },
    data () {
      return {
        sf: 'createdAt',
        so: 'desc',
        columns: [
          { name: 'title', text: 'Title', formatter: this.languageFormatter, sortable: true, align: 'left' },
          { name: 'createdAt', text: 'Created at', formatter: this.dateFormatter, sortable: true, align: 'left' }
        ],
        actions: [
          { label: 'Add Question', click: () => this.$router.push({ name: 'QuestionCategoryList' }) },
          { label: 'Add Questionnaire', click: () => this.checkQuestionnaireLimit() }
        ]
      }
    },
    methods: {
      ...mapActions('pagination/questionnaire', ['paginate']),
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      fetchCurrentPage: async function () {
        try {
          const newPage = parseInt(this.$route.query.page, 10) || 1
          await QuestionnaireModel.deleteAll()
          const result = await QuestionnaireModel.api().get('/questionnaire', {
            dataKey: 'items',
            params: { search: this.query, sf: this.sf, so: this.so, l: this.pagination.perPage, lo: newPage - 1 }
          })
          if (result.response && result.response.data && result.response.data.total) {
            this.paginate({
              perPage: this.pagination.perPage,
              currentPage: newPage,
              total: result.response.data.total
            })
          }
        } catch (e) { console.log('e', e)}
      },
      sortChange: function ({ column, prop, order }) {
        this.sf = prop || 'createdAt'
        this.so = (order || 'descending') === 'ascending' ? 'asc' : 'desc'
        this.fetchCurrentPage()
      },
      changePage (val) {
        const page = val > 1 ? val : undefined
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, page } })
      },
      confirmAndDelete: function (questionnaire) {
        this.$dialog.confirm(this.$t(`Confirm`), this.$t('Are you sure to delete {questionnaire}?', { questionnaire: this.$options.filters.languageString(questionnaire.title) }), this.$t('Delete'))
          .then(async () => {
            await QuestionnaireModel.api().delete(`/questionnaire/${questionnaire._id}`)
            await this.fetchCurrentPage()
          })
      },
      checkQuestionnaireLimit: function () {
          let questionnaireLimit = this.$auth.user.customer.settings.contract.questionaireLimit
          if (this.questionnaires.length >= questionnaireLimit) {
              this.$dialog.info(this.$t('Information'), this.$t('You reached the questionnaire limit.<br>For more informations please contact the administrator.', { limit: questionnaireLimit }), 'OK')
          } else {
              this.$router.push({ name: 'QuestionnaireCreate' })
          }
      }
    },
    computed: {
      questionnaires: () => QuestionnaireModel.all(),
      ...mapState('pagination', {
        pagination: (pagination) => pagination.questionnaire
      })
    },
    async mounted () {
      await this.fetchCurrentPage()
    },
    watch: {
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCurrentPage()
        }
      }
    }
  }
</script>
